module.exports = __webpack_public_path__ + "static/media/undraw_Ordinary_day_re_v5hy.f1fe045e.png";